/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Leavedescription2Inputs */

const zh_organizationsettings_leavedescription2 = /** @type {(inputs: Organizationsettings_Leavedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确定要离开此组织吗？你将失去所有共享资源的访问权限，需要重新被邀请才能再次加入。`)
};

const en_organizationsettings_leavedescription2 = /** @type {(inputs: Organizationsettings_Leavedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to leave this organization? You will lose access to all shared resources and will need to be re-invited to rejoin.`)
};

const es_organizationsettings_leavedescription2 = /** @type {(inputs: Organizationsettings_Leavedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Estás seguro de que quieres abandonar esta organización? Perderás acceso a todos los recursos compartidos y necesitarás ser reinvitado para volver a unirte.`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to leave this organization? You will lose access to all shared resources and will need to be re-invited to rejoin." |
*
* @param {Organizationsettings_Leavedescription2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_leavedescription2 = /** @type {((inputs?: Organizationsettings_Leavedescription2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Leavedescription2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_leavedescription2(inputs)
	if (locale === "en") return en_organizationsettings_leavedescription2(inputs)
	return es_organizationsettings_leavedescription2(inputs)
});
export { organizationsettings_leavedescription2 as "organizationSettings_leaveDescription" }